export type SocialPostImagePromptInput = {
  industry: string;
  subject: string;
  additionalInfo: string;
  /** Red objetivo del posteo visual. */
  platform?: string;
  /** Nombre comercial opcional para branding genérico en la pieza. */
  brandName?: string;
};

const clean = (value: string) => value.trim().replace(/\s+/g, " ");

/**
 * Prompt para generar una pieza gráfica cuadrada tipo post de redes (flyer/creativo),
 * no una foto suelta ni un mockup de la app de Instagram.
 */
export function buildSocialPostImagePrompt({
  industry,
  subject,
  additionalInfo,
  platform = "Instagram",
  brandName,
}: SocialPostImagePromptInput): string {
  const rubro = clean(industry) || "negocio local";
  const asunto = clean(subject) || "novedad del mes";
  const extra = clean(additionalInfo);
  const marca = brandName ? clean(brandName) : "";

  const sections = [
    `Generá una pieza gráfica cuadrada (1:1) lista para publicar en ${platform}, con estilo de creativo profesional para redes sociales (diseño de agencia / marketing digital).`,
    "",
    "CONTEXTO DEL FORMULARIO:",
    `- Industria o rubro: ${rubro}`,
    `- Asunto del posteo: ${asunto}`,
    extra
      ? `- Información adicional: ${extra}`
      : "- Información adicional: reforzá el mensaje con un beneficio claro para la audiencia.",
    marca ? `- Marca o negocio (si aplica en el diseño): ${marca}` : "",
    "",
    "QUÉ DEBE COMUNICAR LA PIEZA:",
    "- El asunto del posteo debe verse como titular principal.",
    "- La información adicional debe convertirse en el mensaje promocional o beneficio central (descuento, plazo, servicio, evento, etc.).",
    "- El diseño debe sentirse coherente con la industria indicada (colores, iconografía, fotografía o ilustración de apoyo).",
    "",
    "COMPOSICIÓN RECOMENDADA:",
    "- Layout de post promocional: titular + bloque de oferta/mensaje + apoyo visual del rubro.",
    "- Tipografía grande, legible y jerárquica (título > mensaje clave > detalle).",
    "- Incluí texto en español integrado en el diseño (porcentajes, fechas, CTAs si corresponden a la info adicional).",
    "- Estética moderna, limpia y lista para feed; alta calidad, buen contraste.",
    "",
    "EVITAR:",
    "- Mockups de celular, capturas de Instagram, UI de la app (likes, comentarios, stories, barras del sistema).",
    "- Imagen solo fotográfica sin diseño ni mensaje.",
    "- Texto ilegible, deformado, en inglés salvo nombres propios, o lorem ipsum.",
    "- Logos reales de marcas famosas que no fueron provistas.",
    "",
    "SALIDA:",
    "- Una sola pieza gráfica final cuadrada, sin bordes de dispositivo ni marco de red social.",
  ];

  return sections.filter(Boolean).join("\n");
}
